import React, { Component } from "react"
import { connect } from "react-redux"
import Modal from 'react-modal'
import { reduxForm, reset } from "redux-form"
import nesProp from 'nested-property'
import moment from "moment"
import i18n from 'lib/i18n'
import { customModalStyles } from "./shared/customStyles"
import ClaimWizardStepOne from "./ClaimWizardStepOne"
import {
    toggleLegalAid, resetClaimWizard, setClaimWizardStep, addOptionalParty, removeOptionalParty,
    updatePartyField, updateInvolvedParties, setDocumentsForStepThree,
    setAlternativeDocType, addClaimWizardOptionalDocument, removeClaimWizardOptionalDocument, updateClaimWizardOptionalDocument,
    updateClaimStatus, addFilesToClaimWizardState, removeDocumentFileFromClaimWizard,
    uploadClaimWizardDocuments, updateClaimWizardPackage, showLoader, hideLoader,
    fetchClientOptionsDict, getClaimWizardPackage, fetchClient, claimConfirmation, updateClaimComment,
    setHasSubQualifications,
    updatePackagesFromConnective, getOneDsPackageById, recreateDsPackage, resendClientRemainder, getDSStakeholders,
    upsertDSPackageEmailStatus,
    updateDSStakeholder,
} from '../../state/actions'
import {
    setInitialValues, setMobilePhoneOptions, setPhoneNumbersOptions, stepOneFormFields, getAndSetProductsAndRisks,
    setEmailOptions, resetProductAndRisk, prepareDataForClaim, saveNewClaim,
    setAccountOptions, validate, setRiskAndQualificationsOptions, updateFormFieldsAfterClaimUpdate,
    updatedFormValue, updateClaimContactAndSetStep2,
    generateInvolvedPartiesData,
    openOverviewPdf,
    missingWizardDocuments,
} from "./claimsWizardService";
import WizardButtons from "./shared/WizardButtons/WizardButtons"
import ClaimWarningModal from "./ClaimWarningModal"
import ClaimWizardStepTwo from "./ClaimWizardStepTwo"
import { generateClientDicts } from 'lib/helpers'
import zipCodes from '../bpostSelect.json'
import ClaimWizardStepThree from "./ClaimWizardStepThree"
import c from 'state/constants'
import ClaimWizardStepFour from "./ClaimWizardStepFour"
import { getClaimMongoRecord } from "./claimsWizardService"
import AreYouSureModal from "../DSDocuments/AreYouSureModal"
import ReminderEmailStatusDialog from "../DSDocuments/reminderEmailStatusDialog"

const _ = i18n('claimWizard')

@connect(state => {
    //this will be a property with in authenticate to determine if user has self managing permission in step one 
    const brokersList = state.office.brokers
    const clientData = state.clients.clientData
    const isLegalAid = state.claimWizard.isLegalAid
    const hasSubQualifications = state.claimWizard.hasSubQualifications
    const claimData = state.claimWizard.claimData
    const wizardStep = state.claimWizard.wizardStep
    const involvedPartiesData = state.claimWizard.involvedPartiesData
    const claimWizardDocumentsData = state.claimWizard.claimWizardDocumentsData
    const dsPackages = state.claimWizard.dsPackages
    const involvedParties = state.claimWizard.involvedParties
    const optionalParties = state.claimWizard.optionalParties
    const documents = state.claimWizard.documents
    const appLanguage = state.app.lang
    const clientOptionsDict = generateClientDicts(state.client.clientOptionsDict, appLanguage)
    const contracts = state.contracts
    const documentFiles = state.claimWizard.documentFiles
    const module = state.app.module
    const clientSubModule = state.clients.subModule
    const clientAccess = state.app.security.actions
    let canCreateMifid = false
    clientAccess.map(oneAccess => {
        if (oneAccess.actionName == 'createmifid') {
            canCreateMifid = oneAccess.actionAllowed === "true" ? true : false
        }
    })

    return {
        brokersList, clientData, claimData, isLegalAid, wizardStep, involvedPartiesData, documents, involvedParties,
        clientOptionsDict, optionalParties, claimWizardDocumentsData, contracts, lang: appLanguage, documentFiles, module,
        clientSubModule, dsPackages, canCreateMifid, hasSubQualifications
        // initializeForm: initialValues => dispatch(initialize('claimWizardForm', initialValues))
    }
})
@reduxForm({
    form: 'claimWizardForm',
    fields: [
        ...stepOneFormFields
    ],
    validate
})
export default class ClaimsWizard extends Component {
    static propTypes = {
        contractNumber: React.PropTypes.string,
        claimNumber: React.PropTypes.string,
        brokerNumber: React.PropTypes.string,
        onGoing: React.PropTypes.bool,
        isClientContract: React.PropTypes.bool,
    }
    constructor(props) {
        super(props)

        // Check if Contract has a ongoing claim and fetch all data if there is a ongoing claim
        const isExistingClaim = props.claimData && props.claimData.claimStatus === '8' || props.onGoing || false

        let claimWarningModalStep = ''
        if (isExistingClaim && !props.onGoing) {
            claimWarningModalStep = '1'
        }
        const zipCodeOptions = zipCodes.map(({ zip, city }) => {
            return {
                value: `${zip}_${city}`,
                label: `${zip} ${city}`
            }
        })

        const contractDetails = props.contracts[props.contractId]

        this.state = {
            isExistingClaim,
            returnToClaimWizard: false,
            claimWarningModalStep,
            brokersOptions: [],
            mobilePhoneOptions: [],
            phoneNumberOptions: [],
            emailOptions: [],
            productList: [],
            productListOptions: [],
            riskOptionsList: [],
            qualificationOptionsList: [],
            accountNumberOptions: [],
            qualificationList: [],
            subQualificationOptionsList: [],
            claimData: props.claimData,
            zipCodeOptions,
            mandatoryInvPartyOptions: [],
            optionalInvPartyOptions: [],
            contractDetails,
            isDragging: ''
        }
    }

    // ================================
    // #region Init
    // ================================

    async componentDidMount() {
        const { dispatch, brokersList, fields, clientId, clientData, contractId, brokerNumber } = this.props
        const { claimData, isExistingClaim } = this.state
        const brokerData = brokersList[brokerNumber]
        const brokerName = brokerData && `${brokerData.main.name} [${brokerNumber}]`
        let selfManaging = true
        if (brokerData && brokerData.main) {
            selfManaging = brokerData.main.selfManagingVisible
        }
        //handle client data 
        let selectedClientData
        if (clientData && clientData[clientId]) {
            selectedClientData = clientData[clientId]
        }
        else {
            const getClientResponse = await dispatch(fetchClient(claimData.clientId))
            dispatch(fetchClientOptionsDict())
            selectedClientData = getClientResponse.client
        }

        let claimDataResolved = claimData;
        if (!claimData || Object.keys(claimData).length === 0) {
            claimDataResolved = await getClaimMongoRecord(dispatch, { contractId });
            this.setState({ claimData: claimDataResolved });
        }

        // map phone numbers, emails and account numbers from client
        const mobilePhoneOptions = setMobilePhoneOptions(selectedClientData.detail.phoneNumbers)
        const phoneNumberOptions = setPhoneNumbersOptions(selectedClientData.detail.phoneNumbers)
        const emailOptions = setEmailOptions(selectedClientData.detail.emails)
        const accountNumberOptions = setAccountOptions(selectedClientData.detail.accountNumbers)

        // get product, risk and qualifications, and create options lists
        const claimDate = isExistingClaim && claimData && claimData.claimDate ? moment(claimData.claimDate).format('YYYY-MM-DD') : claimDataResolved && claimDataResolved.claimDate ? moment(claimDataResolved.claimDate).format('YYYY-MM-DD') : ''
        const productsListAndOptions = await getAndSetProductsAndRisks(dispatch, contractId, claimDate, fields)

        let riskOptionsList = [], qualificationList = [], qualificationOptionsList = [], subQualificationOptionsList = []
        if (isExistingClaim && (claimData.productId || claimDataResolved.productId)) {
            const riskAndQualificationOptions = await setRiskAndQualificationsOptions(dispatch, claimData.productId || claimDataResolved.productId, productsListAndOptions.productsList, claimData.selfManaging, claimData.contractId, claimData.contractIdHist)
            riskOptionsList = riskAndQualificationOptions.riskOptionsList
            qualificationList = riskAndQualificationOptions.qualificationList
            qualificationOptionsList = riskAndQualificationOptions.qualificationOptionsList
            // handle subqualifications for existing claim
            if (claimDataResolved && claimDataResolved.subQualificationNumber) {

                const qualification = qualificationList.find(oneQualification => oneQualification.qualificationNumber === claimDataResolved.qualificationNumber)

                if (qualification.subQualifications && qualification.subQualifications.length > 0) {
                    qualification.subQualifications.forEach(oneSubQualification => {
                        subQualificationOptionsList.push({
                            value: oneSubQualification.subQualificationNumber,
                            label: oneSubQualification.subQualificationName
                        })
                    })
                }
            }
        }

        if (subQualificationOptionsList.length > 0) {
            dispatch(setHasSubQualifications(true))
        }

        this.setState({
            accountNumberOptions, selfManaging,
            mobilePhoneOptions, phoneNumberOptions, emailOptions,
            productList: productsListAndOptions.productsList,
            productListOptions: productsListAndOptions.productListOptions,
            riskOptionsList, qualificationList, qualificationOptionsList,
            subQualificationOptionsList
        }, () => {
            setInitialValues(dispatch, (claimData && Object.keys(claimData).length > 0 ? claimData : claimDataResolved), fields, {
                brokerName, clientData: selectedClientData, claimComment: claimData.claimComment || isExistingClaim ? claimDataResolved.claimComment : '',
                mobilePhoneOptions, phoneNumberOptions, emailOptions
            })
        })
    }

    componentDidUpdate(prevProps) {
        const { claimData, fields, dispatch, clientOptionsDict, involvedParties, optionalParties } = this.props

        if (claimData !== prevProps.claimData) {
            const isExistingClaim = claimData && claimData.claimStatus === '8' || false
            if (claimData.claimNumber) {
                updateFormFieldsAfterClaimUpdate(dispatch, fields, claimData)
            }
            this.setState({ isExistingClaim })

        }
        if (involvedParties !== prevProps.involvedParties) {

            const mandatoryInvPartyOptions = involvedParties.map(oneParty => {
                const onePartyOption = clientOptionsDict.involvedParties.find(i => i.value === oneParty.partyNumber)
                return onePartyOption
            })
            this.setState({ mandatoryInvPartyOptions })

        }
        if (optionalParties !== prevProps.optionalParties) {
            const optionalInvPartyOptions = optionalParties.map(oneParty => {
                const onePartyOption = clientOptionsDict.involvedParties.find(i => i.value === oneParty)
                return onePartyOption
            })
            optionalInvPartyOptions.sort((a, b) => a.label.localeCompare(b.label));
            this.setState({ optionalInvPartyOptions })
        }
    }

    /**
     * This will initialize step three of the claim wizard
     * First will get documents records stored in mongo
     * Than using documents records from mongo and documents from the getDocumentation procedure will create a list of documents
     * These processes will be done in redux actions
     * At the moment getClaimWizardDocuments is not implemented will only create the initial list
     */
    async initializeStepThree() {
        const { dispatch, claimData, documents } = this.props
        await dispatch(setDocumentsForStepThree(claimData._id, claimData))
    }

    // #endregion

    // ================================
    // #region Handlers
    // ================================

    handleCloseWizardMethod(forceClose = false) {
        const { dispatch, closeWizard } = this.props
        const { returnToClaimWizard, claimWarningModalStep } = this.state

        // if cancelClaim modal is opened from claimWizard step one we need to return to claim wizard on cancel
        if (returnToClaimWizard && claimWarningModalStep && !forceClose) {
            this.setState({ returnToClaimWizard: false, claimWarningModalStep: '' })
        } else {
            dispatch(resetClaimWizard())

            closeWizard()
        }
    }

    async handleOnCreateClaim() {
        const { dispatch, fields, errors, clientId, contractId, brokerNumber, lang, contractNumber } = this.props
        //check validation first
        // ... 
        // prepare data
        const claimData = prepareDataForClaim(fields.stepOne)
        claimData['clientId'] = clientId
        claimData['contractId'] = contractId
        claimData['brokerNumber'] = brokerNumber
        claimData['contractNumber'] = contractNumber
        //language used for claimOverview
        claimData['language'] = lang


        // call api
        dispatch(showLoader())
        await saveNewClaim(dispatch, claimData)
        dispatch(hideLoader())
    }

    async handleOnUpdateClaimContact() {
        const { dispatch, claimData, fields } = this.props
        dispatch(showLoader())
        await updateClaimContactAndSetStep2(dispatch, claimData, fields)
        dispatch(hideLoader())
    }

    async handleOnClaimCancel() {
        const { dispatch, claimData, clientData, clientId, fields, brokersList, brokerNumber, isClientContract, closeWizard } = this.props
        const { mobilePhoneOptions, phoneNumberOptions, emailOptions } = this.state
        const claimId = claimData.claimId
        const digitalClaimPackageId = claimData._id
        const claimStatus = '6'
        await dispatch(updateClaimStatus({ claimId, claimStatus, digitalClaimPackageId }))

        //reset form and set initial values
        await dispatch(resetClaimWizard());
        dispatch(reset('claimWizardForm'))
        if (!isClientContract) {
            closeWizard()
        } else {
            let selectedClientData
            const brokerData = brokersList[brokerNumber]
            const brokerName = brokerData && `${brokerData.main.name} [${brokerNumber}]`
            if (clientData && clientData[clientId]) {
                selectedClientData = clientData[clientId]
            }

            this.setState(
                {
                    returnToClaimWizard: false, claimWarningModalStep: '',
                    qualificationOptionsList: [],
                    subQualificationOptionsList: []
                },
                setInitialValues(dispatch, null, fields, {
                    brokerName,
                    clientData: selectedClientData,
                    mobilePhoneOptions,
                    phoneNumberOptions,
                    emailOptions,
                })
            )
        }

    }

    /***
     * Handle self managing change in step one
     * If self managing is set to true filter qualification options list and remove legal aid true options
     * If there is already a legal aid qualification selected set reset the qualificationNumber and qualificationLabel to default ''
     */
    async onHandleSelfManagingChange(value) {
        const { fields, dispatch } = this.props

        if (fields.stepOne.productId.value) {
            let riskOptionsList = [], qualificationList = [], qualificationOptionsList = []
            const riskAndQualificationOptions = await setRiskAndQualificationsOptions(dispatch, fields.stepOne.productId.value, this.state.productList, value, contractId, fields.stepOne.contractIdHist)
            riskOptionsList = riskAndQualificationOptions.riskOptionsList
            qualificationList = riskAndQualificationOptions.qualificationList
            qualificationOptionsList = riskAndQualificationOptions.qualificationOptionsList
            this.setState({ riskOptionsList, qualificationList, qualificationOptionsList })
        }
    }

    async handleUpdateInvolvedParties() {
        const { dispatch, involvedPartiesData, claimData } = this.props
        const involvedParties = generateInvolvedPartiesData(involvedPartiesData)
        const args = {
            claimId: claimData.claimId,
            involvedParties: involvedParties
        }
        await dispatch(updateInvolvedParties(args))
        await dispatch(getClaimWizardPackage({ contractId: claimData.contractId }))
    }

    async handleDateChange(newDate) {
        const { contractId, dispatch, fields } = this.props
        resetProductAndRisk(fields, dispatch)
        dispatch(toggleLegalAid(false))
        if (!newDate) {
            // no date reset all lists
            this.setState({
                productList: [],
                productListOptions: [],
                riskOptionsList: [],
                qualificationOptionsList: [],
                subQualificationOptionsList: []
            })
        } else {
            const productsListAndOptions = await getAndSetProductsAndRisks(dispatch, contractId, newDate, fields)
            this.setState({
                productList: productsListAndOptions.productsList,
                productListOptions: productsListAndOptions.productListOptions,
                riskOptionsList: []
            })
        }
    }

    async handleProductChange(newProductId) {
        const { productList } = this.state
        const { dispatch, fields, contractId } = this.props
        const { riskOptionsList, qualificationList, qualificationOptionsList } =
            await setRiskAndQualificationsOptions(dispatch, newProductId.value, productList, fields.stepOne.selfManaging.value, contractId, fields.stepOne.contractIdHist.value)
        dispatch(toggleLegalAid(false))
        this.setState({ riskOptionsList, qualificationOptionsList, qualificationList })
    }

    handleQualificationChange(newQualificationNumber) {
        const { qualificationList } = this.state
        const { dispatch, fields } = this.props
        const subQualificationOptionsList = []
        const qualification = qualificationList.find(oneQualification => oneQualification.qualificationNumber === newQualificationNumber.value)
        let isLegalAid = false

        //if is legal aid add subQualification and set selfManaging to default 'false'
        if (qualification.subQualifications && qualification.subQualifications.length > 0) {
            qualification.subQualifications.forEach(oneSubQualification => {
                subQualificationOptionsList.push({
                    value: oneSubQualification.subQualificationNumber,
                    label: oneSubQualification.subQualificationName
                })
            })
        }

        if (qualification.legalAid === 'true') {
            isLegalAid = true
            updatedFormValue({ value: 'false', touched: true }, fields.stepOne.selfManaging, dispatch)
        }
        updatedFormValue({ value: '', touched: true }, fields.stepOne.subQualificationNumber, dispatch)

        dispatch(toggleLegalAid(isLegalAid))
        subQualificationOptionsList.sort((a, b) => a.label.localeCompare(b.label))
        if (subQualificationOptionsList.length > 0) {
            dispatch(setHasSubQualifications(true))
        } else {
            dispatch(setHasSubQualifications(false))
        }
        this.setState({ subQualificationOptionsList })
    }

    /**
     * On click the continue existing on-going claim will close cancelation modal and go to claim wizard step 1
     */
    handleContinueExistingClaim() {
        const { dispatch } = this.props
        this.setState({ claimWarningModalStep: '' }, () => {
            dispatch(setClaimWizardStep('1'))
        })
    }

    /**
     * This will will move to step in the warning modal when is opened before step one
     */
    handleSetStepTwoWarningModal() {
        this.setState({ claimWarningModalStep: '2' })
    }

    /**
     * Open cancel claim modal from claim wizard, on cancel button we need to keep claim wizard modal open 
     * This will open the warning modal on step two and three
     */
    handleOpenWarningClaimModal() {
        this.setState({ claimWarningModalStep: '2', returnToClaimWizard: true })
    }

    /**
     * Add optional party to the list of optional parties on step two
     */
    handleOnAddOptionalParty() {
        const { dispatch } = this.props
        dispatch(addOptionalParty())
    }
    /**
     * Remove optional party from the list of optional parties on step two
     * @param {*} partyId 
     */
    handleOnRemoveOptionalParty(partyId) {
        const { dispatch } = this.props
        dispatch(removeOptionalParty(partyId))
    }

    /**
     * Update party field on step two
     * @param {*} value 
     * @param {*} partyId 
     * @param {*} field 
     */
    handleUpdatePartyField(value, partyId, field) {
        const { dispatch } = this.props
        dispatch(updatePartyField(value, partyId, field))
    }

    /**
     * Handle selected alternative document on step three
     * @param {*} value 
     * @param {*} docType 
     */
    handleSelectedAlternativeDocument(value, docType) {
        const { dispatch } = this.props
        dispatch(setAlternativeDocType(value, docType))
    }

    handleAddClaimWizardOptionalDocument() {
        const { dispatch } = this.props
        dispatch(addClaimWizardOptionalDocument())
    }

    handleRemoveClaimWizardOptionalDocument(tempId) {
        const { dispatch } = this.props
        dispatch(removeClaimWizardOptionalDocument(tempId))
    }

    handleUpdateClaimWizardOptionalDocument(value, tempId) {
        const { dispatch } = this.props
        dispatch(updateClaimWizardOptionalDocument(value, tempId))
    }

    handleAddFilesToClaimWizardState(files) {
        const { dispatch } = this.props
        dispatch(addFilesToClaimWizardState(files))
    }

    handleRemoveDocumentFile(fileId) {
        const { dispatch } = this.props
        dispatch(removeDocumentFileFromClaimWizard(fileId))
    }

    handleSetFileDrag(isDragging) {
        this.setState({ isDragging })
    }

    async handleAddDSPackageToClaimPackage(dsPackageId) {
        const { dispatch, claimData } = this.props
        const claimWizardId = claimData._id
        const existingDSPackages = claimData.dsPackages ? claimData.dsPackages.map(onePackage => onePackage.dsPackage) : []
        if (!existingDSPackages.includes(dsPackageId)) {
            existingDSPackages.push(dsPackageId)
        } else {
            dispatch(showLoader())
            await dispatch(getClaimWizardPackage({ contractId: claimData.contractId }))
            await dispatch(setDocumentsForStepThree(claimData._id, claimData))
            dispatch(hideLoader())
            return
        }
        dispatch(showLoader())
        await dispatch(updateClaimWizardPackage(claimWizardId, { dsPackages: existingDSPackages }))
        await dispatch(getClaimWizardPackage({ contractId: claimData.contractId }))
        dispatch(hideLoader())
    }

    async handleFilesUpload(files) {
        const { dispatch, claimData } = this.props
        dispatch(showLoader())
        await dispatch(uploadClaimWizardDocuments(files, claimData.claimId, claimData._id))
        await dispatch(getClaimWizardPackage({ contractId: claimData.contractId }))
        dispatch(hideLoader())
    }

    /**
     * This method will update package from connective reactivating the main sining link and opens the signing page from connective
     * @param {*} packageId
     */
    async onDirectSignButtonClick(packageId) {
        const { dispatch } = this.props
        const responseFromConnective = await dispatch(updatePackagesFromConnective([packageId]))
        if (responseFromConnective.success) {
            const dsPackage = await dispatch(getOneDsPackageById(packageId))
            let URLForSign = nesProp.get(dsPackage, "F2FSigningUrl")
            // this.setState({ dsPackage })
            window.open(URLForSign, '_blank', 'noopener,noreferrer')
        }
    }

    /**
     * Handle the reset process, when the user click on the reset button
     * @param {object} dsPackage
     * @returns nothing
     */
    onClickRecreatePackage = async (dsPackage) => {
        const { dispatch, claimData } = this.props

        // this function will be called when the operation is failed
        // it will show a popup with the error message
        let onErrorPopup = async (error) => {
            return this.setState({
                isOpenAreYouSure: {
                    title: _('areYouSureModalTitle'),
                    message: _('recreatePackageError') + " " + _(error.name) + " code:" + _(error.callIDForDebug),
                    noCancelButton: true,
                    callBackCancel: () => {
                        this.setState({ isOpenAreYouSure: false })
                    },
                    callBackOk: async () => {
                        this.setState({ isOpenAreYouSure: false })
                    }
                }
            })
        }

        // this function will be called when the operation is success
        // it will show a popup with the success message
        let onSuccessPopup = async () => {
            return this.setState({
                isOpenAreYouSure: {
                    title: _('areYouSureModalTitle'),
                    message: _('recreatePackageSuccess'),
                    noCancelButton: false,
                    callBackCancel: () => {
                        this.setState({ isOpenAreYouSure: false })
                    },
                    callBackOk: async () => {
                        this.setState({ isOpenAreYouSure: false, autoOpenMifid: true })
                    }
                }
            })
        }

        // this function will be called when the user click on the confirm button
        // it will call the backend to recreate the package
        let onConfirmResetCallback = async () => {
            try {
                await dispatch(recreateDsPackage(dsPackage.id))
                await dispatch(getClaimWizardPackage({ contractId: claimData.contractId }))
                await this.initializeStepThree()
                return onSuccessPopup()
            } catch (error) {
                console.error(error)
                return onErrorPopup(error)
            }
        }

        // this is an init data for the popup on the first time to ask the user if he is sure to recreate the package
        let initAreYouSureData = {
            title: _('areYouSureModalTitle'),
            message: _('areYouSureToRecreteThePackage'),
            callBackCancel: () => {
                this.setState({ isOpenAreYouSure: false })
            },
            callBackOk: onConfirmResetCallback
        }

        // show the popup to ask the user if he is sure to recreate the package
        return this.setState({ isOpenAreYouSure: initAreYouSureData })
    }

    onResendRemindersClick = async (packageId) => {
        const { dispatch } = this.props

        const reminderResponse = await dispatch(resendClientRemainder(packageId))
        let reminderSentSuccessFlag = false
        if (reminderResponse && reminderResponse.success) {
            reminderSentSuccessFlag = true
        }
        this.setState({ reminderConfirmationModal: true, reminderSentSuccessFlag })
    }

    getDsStakeholdersForInvitation = async stakeholderIdArray => {
        const { dispatch } = this.props
        return await dispatch(getDSStakeholders(stakeholderIdArray))
    }

    handleUpdatesAfterSigningInvitation = async (responses, dsPackage, stakeholders) => {
        const { dispatch, claimData } = this.props
        try {
            if (!responses || responses.length === 0) {
                return
            }

            for (let i = 0; i < responses.length; i++) {
                let emailId = nesProp.get(responses, i + ".emailRecord._id")
                let toEmailAddress = nesProp.get(responses, i + ".emailRecord.toEmailAddress")

                if (!emailId) { continue }

                // update all stakeholder as invited
                for (let j = 0; j < stakeholders.length; j++) {
                    if (toEmailAddress && toEmailAddress.length > 0 &&
                        toEmailAddress.some((email) =>
                            (String(email).toLowerCase() === String(stakeholders[j].email).toLowerCase())
                        )
                    ) {
                        await dispatch(upsertDSPackageEmailStatus(
                            dsPackage._id, emailId, { isInvitation: true, stakeholderId: stakeholders[j]._id } /* --> ?? mailOptions*/
                        ))
                        await dispatch(updateDSStakeholder(
                            { stakeholderId: stakeholders[j]._id, isInvited: true }
                        ))
                    }
                }

                // dsPackage = await dispatch(getOneDsPackageById(dsPackage._id))
            }

            await dispatch(getClaimWizardPackage({ contractId: claimData.contractId }))
            await this.initializeStepThree()
            // await dispatch(setDocumentsForStepThree(claimData._id, claimData))
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    // #endregion

    // ================================
    // #region Render
    // ================================

    renderWizardButtons() {
        const { claimWarningModalStep, isExistingClaim } = this.state
        const { errors, fields, wizardStep, documentFiles, brokerNumber, lang, claimData, documents, dispatch } = this.props
        const unfinishedDsPackageFiles = documentFiles.filter(file => file.dsPackageStatus && file.dsPackageStatus !== 'packageStatusFinished' && !file.uploaded
            && claimData.oraDocuments.find(doc => doc.required === 'Wizard' && (doc.docType === file.docType || doc.alternativeDocTypes.some(altDoc => altDoc.altDocType === file.docType)))
        )

        const leftBtn = {
            disabled: false,
            label: _('cancelClaimButton'),
            isHidden: true
        }

        const cancelBtn = {
            disabled: false,
            method: () => this.handleCloseWizardMethod(),
            label: _('cancel')
        }
        const previousBtn = {
            isHidden: true
        }
        const nextBtn = {
            disabled: false,
            label: _('next')
        }
        const middleActionBtn = {
            isHidden: true
        }

        const missingDocs = missingWizardDocuments(claimData.missingInfo, claimData.oraDocuments, documents, documentFiles)

        if (!claimWarningModalStep && wizardStep) {
            switch (wizardStep) {
                case '1':
                    leftBtn.method = this.handleOpenWarningClaimModal.bind(this)
                    leftBtn.isHidden = !isExistingClaim

                    nextBtn.disabled = errors && errors.stepOne ? true : false
                    nextBtn.method = isExistingClaim ? this.handleOnUpdateClaimContact.bind(this) : this.handleOnCreateClaim.bind(this)
                    nextBtn.label = (isExistingClaim ? _('next') : _('saveClaimButton'))
                    break;

                case '2':
                    //on cancel set the confirmation modal to confirm cancel or save data
                    cancelBtn.method = this.handleOpenWarningClaimModal.bind(this)

                    previousBtn.isHidden = false
                    previousBtn.label = _('previous')
                    previousBtn.method = async () => {
                        await this.handleUpdateInvolvedParties()
                        return dispatch(setClaimWizardStep('1'))
                    }
                    nextBtn.method = async () => {
                        dispatch(showLoader())
                        await this.handleUpdateInvolvedParties()
                        await this.initializeStepThree()
                        dispatch(hideLoader())
                        return dispatch(setClaimWizardStep('3'))
                    }
                    break
                case '3':
                    // HANDLE CANCEL CLAIM MODAL IN STEP 3
                    cancelBtn.method = () => {
                        if (documentFiles.length > 0 && documentFiles.some(file => !file.uploaded && !file.dsPackageStatus)) {
                            this.handleOpenWarningClaimModal()
                        } else {
                            this.handleCloseWizardMethod()
                        }
                    }
                    previousBtn.isHidden = false
                    previousBtn.label = _('previous')
                    previousBtn.method = async () => {
                        if (documentFiles.length > 0 && documentFiles.some(file => !file.uploaded && !file.dsPackageStatus)) {
                            await this.handleFilesUpload(documentFiles)
                        }
                        if (!documentFiles.some(file => file.error)) {
                            dispatch(setClaimWizardStep('2'))
                        }
                    }
                    nextBtn.method = async () => {
                        if (documentFiles.length > 0 && documentFiles.some(file => !file.uploaded && !file.dsPackageStatus)) {
                            await this.handleFilesUpload(documentFiles)
                        }
                        if (!documentFiles.some(file => file.error)) {
                            dispatch(setClaimWizardStep('4'))
                        }
                    }
                    nextBtn.label = _('next')
                    break
                case '4':
                    cancelBtn.method = () => {
                        if (fields.stepFour.claimComment.value) {
                            this.handleOpenWarningClaimModal()
                        } else {
                            this.handleCloseWizardMethod()
                        }
                    }

                    previousBtn.isHidden = false
                    previousBtn.label = _('previous')
                    previousBtn.method = async () => {
                        dispatch(showLoader())
                        await dispatch(updateClaimComment(claimData.claimId, fields.stepFour.claimComment.value))
                        await dispatch(getClaimWizardPackage({ contractId: claimData.contractId }))
                        await this.initializeStepThree()
                        dispatch(hideLoader())
                        return dispatch(setClaimWizardStep('3'))
                    }
                    middleActionBtn.isHidden = false
                    middleActionBtn.label = _('claimOverview')
                    middleActionBtn.method = async () => {
                        await openOverviewPdf(claimData._id)
                    }
                    nextBtn.method = async () => {
                        dispatch(showLoader())
                        await dispatch(updateClaimComment(claimData.claimId, fields.stepFour.claimComment.value))
                        await dispatch(claimConfirmation(claimData.claimId))
                        dispatch(hideLoader())
                        this.handleCloseWizardMethod()
                    }
                    nextBtn.label = _('finalizeClaim')
                    //disable the finalize claim button in case mandatory data is not filled in or if there are dsDocuments unfinished
                    nextBtn.disabled = claimData.missingInfo &&
                        (claimData.missingInfo.involvedParties && claimData.missingInfo.involvedParties.length > 0 ||
                            missingDocs && missingDocs.length > 0 ||
                            unfinishedDsPackageFiles && unfinishedDsPackageFiles.length > 0
                        )
                    break
                default:
                    break;
            }
        } else if (claimWarningModalStep) {
            leftBtn.method = this.handleContinueExistingClaim.bind(this)
            leftBtn.label = _('continueExistingClaimBtn')
            leftBtn.isHidden = claimWarningModalStep === '1' ? false : true

            cancelBtn.disabled = false
            cancelBtn.method = () => this.handleCloseWizardMethod()
            cancelBtn.label = _('cancel')

            if (wizardStep === '1') {
                nextBtn.method = claimWarningModalStep === '1' ? this.handleSetStepTwoWarningModal.bind(this) : this.handleOnClaimCancel.bind(this)
                nextBtn.label = (claimWarningModalStep === '1' ? _('cancelClaimButton') : _('cancelClaimButton2'))
            } else if (wizardStep === '2') {
                //save and exit method
                nextBtn.method = async () => {
                    await this.handleUpdateInvolvedParties()
                    this.handleCloseWizardMethod(true)
                }
                nextBtn.label = _('saveAnddExitButton')

                //exit without saving
                previousBtn.isHidden = false
                previousBtn.method = () => this.handleCloseWizardMethod(true)
                previousBtn.label = _('exitWithoutSaveButton')
            } else if (wizardStep === '3') {
                nextBtn.method = async () => {
                    await this.handleFilesUpload(documentFiles)
                    if (!documentFiles.some(file => file.error)) {
                        this.handleCloseWizardMethod(true)
                    } else {
                        this.setState({ returnToClaimWizard: false, claimWarningModalStep: '' })
                    }
                }
                nextBtn.label = _('saveAnddExitButton')
                previousBtn.isHidden = false
                previousBtn.method = () => this.handleCloseWizardMethod(true)
                previousBtn.label = _('exitWithoutSaveButton')
            } else if (wizardStep === '4') {
                nextBtn.method = async () => {
                    await dispatch(updateClaimComment(claimData.claimId, fields.stepFour.claimComment.value))
                    this.handleCloseWizardMethod(true)
                }
                nextBtn.label = _('saveAnddExitButton')
                previousBtn.isHidden = false
                previousBtn.method = () => this.handleCloseWizardMethod()
                previousBtn.label = _('exitWithoutSaveButton')
            }

        }

        return (
            <WizardButtons
                leftBtn={leftBtn}
                cancelBtn={cancelBtn}
                nextBtn={nextBtn}
                middleActionBtn={middleActionBtn}
                previousBtn={previousBtn}
            />
        )
    }

    render() {
        const { isExistingClaim, mobilePhoneOptions, phoneNumberOptions, productListOptions,
            emailOptions, riskOptionsList, qualificationOptionsList, accountNumberOptions, subQualificationOptionsList,
            claimWarningModalStep, selfManaging, zipCodeOptions, optionalInvPartyOptions, mandatoryInvPartyOptions,
            contractDetails, isOpenAreYouSure, reminderConfirmationModal, reminderSentSuccessFlag
        } = this.state
        const { claimWizardIsOpened, fields, errors, isLegalAid, wizardStep, involvedPartiesData, module, clientSubModule,
            clientOptionsDict, claimWizardDocumentsData, dsPackages, clientData, documents, claimData, dispatch } = this.props

        return (
            <div>
                <Modal
                    isOpen={Boolean(claimWizardIsOpened)}
                    style={customModalStyles}
                    contentLabel={""}
                    key={"DigitalClaimWizardModal"}
                >
                    {(!claimWarningModalStep && (wizardStep && wizardStep === '1')) &&
                        <ClaimWizardStepOne
                            mobilePhoneOptions={mobilePhoneOptions}
                            phoneNumberOptions={phoneNumberOptions}
                            emailOptions={emailOptions}
                            productListOptions={productListOptions}
                            riskOptionsList={riskOptionsList}
                            qualificationOptionsList={qualificationOptionsList}
                            accountNumberOptions={accountNumberOptions}
                            subQualificationOptionsList={subQualificationOptionsList}
                            onClaimDateHandler={this.handleDateChange.bind(this)}
                            handleProductChange={this.handleProductChange.bind(this)}
                            handleQualificationChange={this.handleQualificationChange.bind(this)}
                            dispatch={dispatch}
                            formData={fields.stepOne}
                            errors={errors}
                            selfManaging={selfManaging}
                            isExistingClaim={isExistingClaim}
                            isLegalAid={isLegalAid}
                            handleSelfManagingChange={this.onHandleSelfManagingChange.bind(this)}
                        >
                            {this.renderWizardButtons()}
                        </ClaimWizardStepOne>
                    }
                    {
                        (!claimWarningModalStep && (wizardStep && wizardStep === '2')) &&
                        <ClaimWizardStepTwo
                            involvedPartiesData={involvedPartiesData}
                            onAddOptionalParty={this.handleOnAddOptionalParty.bind(this)}
                            onRemoveOptionalParty={this.handleOnRemoveOptionalParty.bind(this)}
                            updatePartyField={this.handleUpdatePartyField.bind(this)}
                            mandatoryInvPartyOptions={mandatoryInvPartyOptions}
                            optionalInvPartyOptions={optionalInvPartyOptions}
                            countryOptionsList={clientOptionsDict.country}
                            zipCodeOptions={zipCodeOptions}
                        >
                            {this.renderWizardButtons()}
                        </ClaimWizardStepTwo>
                    }
                    {!claimWarningModalStep && (wizardStep && wizardStep === '3') &&

                        <ClaimWizardStepThree
                            claimWizardDocumentsData={claimWizardDocumentsData}
                            dsPackages={dsPackages}
                            canCreateMifid={this.props.canCreateMifid}
                            documentFiles={this.props.documentFiles}
                            claimDocumentsOptions={clientOptionsDict.documentTypeOptions}
                            setAlternativeMethod={this.handleSelectedAlternativeDocument.bind(this)}
                            onAddOptionalDocument={this.handleAddClaimWizardOptionalDocument.bind(this)}
                            onRemoveOptionalDocument={this.handleRemoveClaimWizardOptionalDocument.bind(this)}
                            onChangeOptionalDoctypeId={this.handleUpdateClaimWizardOptionalDocument.bind(this)}
                            directSignMethod={this.onDirectSignButtonClick.bind(this)}
                            recreatePackageMethod={this.onClickRecreatePackage.bind(this)}
                            sendRemindersMethod={this.onResendRemindersClick.bind(this)}
                            getDsStakeholdersForInvitation={this.getDsStakeholdersForInvitation.bind(this)}
                            afterInvUpdates={this.handleUpdatesAfterSigningInvitation.bind(this)}
                            addFilesToClaimWizardState={this.handleAddFilesToClaimWizardState.bind(this)}
                            removeDocumentFile={this.handleRemoveDocumentFile.bind(this)}
                            updateDsPackageList={this.handleAddDSPackageToClaimPackage.bind(this)}
                            setFileDrag={this.handleSetFileDrag.bind(this)}
                            isDragging={this.state.isDragging}
                            claimData={this.props.claimData}
                            clientData={clientData}
                            contractDetails={contractDetails}
                            docsFromDocumentation={documents}
                            lang={this.props.lang}
                        >
                            {this.renderWizardButtons()}
                        </ClaimWizardStepThree>
                    }
                    {!claimWarningModalStep && (wizardStep && wizardStep === '4') &&
                        <ClaimWizardStepFour
                            documentFiles={this.props.documentFiles}
                            documents={documents}
                            involvedPartiesData={involvedPartiesData}
                            involvedParties={this.props.involvedParties}
                            mandatoryInvPartyOptions={mandatoryInvPartyOptions}
                            formData={fields.stepFour}
                            clientOptionsDict={clientOptionsDict}
                            missingInfo={claimData.missingInfo}
                            claimDocumentsOptions={clientOptionsDict.documentTypeOptions}
                            oraDocuments={claimData.oraDocuments}
                            docsFromDocumentation={documents}
                        >
                            {this.renderWizardButtons()}
                        </ClaimWizardStepFour>
                    }
                    {claimWarningModalStep &&
                        <ClaimWarningModal
                            modalTitle={wizardStep === '1' ? _('cancelClaimModal') : wizardStep === '2' ? _('cancelInvolvedParties') :
                                wizardStep === '3' ? _('cancelDocuments') : wizardStep === '4' ? _('cancelClaimComment') : ''}
                            message={
                                wizardStep === '1' && (claimWarningModalStep === '1' ? _('existingClaimMessage') :
                                    claimWarningModalStep === '2' ? _('claimCancelMessage') : '') ||
                                wizardStep === '2' && _('cancelInvolvedPartiesMessage') ||
                                wizardStep === '3' && _('cancelDocumentsMessage') ||
                                wizardStep === '4' && _('cancelClaimCommentMessage')
                            }>
                            {this.renderWizardButtons()}
                        </ClaimWarningModal>
                    }
                </Modal>
                <AreYouSureModal
                    isOpen={Boolean(isOpenAreYouSure)}
                    style={customModalStyles}
                    contentLabel={""}
                    isOpenAreYouSure={isOpenAreYouSure ? isOpenAreYouSure : {}}
                    didClose={() => {
                        this.setState({ isOpenAreYouSure: false })
                    }}
                    key={"AreYouSureModal"}
                ></AreYouSureModal>
                <ReminderEmailStatusDialog
                    isOpen={reminderConfirmationModal}
                    success={reminderSentSuccessFlag}
                    invitationBlocked={false}
                    closeModal={() => this.setState({ reminderConfirmationModal: false })}
                />
            </div>
        )
    }

    // #endregion

}





// WEBPACK FOOTER //
// ./components/ClaimsWizard/Index.jsx